import type { FC } from 'react';
import './CroopLoader.css';

interface CroopBrandLogoProps {
  className?: string;
}

const CroopBrandLogo: FC<CroopBrandLogoProps> = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1100 300"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <svg x="0" y="0" width="300" height="300" viewBox="0 0 512 512">
      <path
        d="M334.2500,391.5330 A156.5,156.5 0 1 1 334.2500,120.4670"
        fill="none"
        stroke="#7433A0"
        strokeWidth="99"
        strokeLinecap="round"
      />
      <g className="croop-brand-logo__arc">
        <path
          d="M354.4886,134.3767 A156.5,156.5 0 0 1 354.4886,377.6233"
          fill="none"
          stroke="#66C0B3"
          strokeWidth="99"
          strokeLinecap="round"
          opacity="0.76"
        />
      </g>
    </svg>
    <g fill="#251B35" transform="translate(330 202) scale(0.087890625 -0.087890625)">
      <path d="M1319 1378V1165Q1217 1260 1101.5 1307.0Q986 1354 856 1354Q600 1354 464.0 1197.5Q328 1041 328 745Q328 450 464.0 293.5Q600 137 856 137Q986 137 1101.5 184.0Q1217 231 1319 326V115Q1213 43 1094.5 7.0Q976 -29 844 -29Q505 -29 310.0 178.5Q115 386 115 745Q115 1105 310.0 1312.5Q505 1520 844 1520Q978 1520 1096.5 1484.5Q1215 1449 1319 1378Z" />
      <path transform="translate(1430 0)" d="M842 948Q811 966 774.5 974.5Q738 983 694 983Q538 983 454.5 881.5Q371 780 371 590V0H186V1120H371V946Q429 1048 522.0 1097.5Q615 1147 748 1147Q767 1147 790.0 1144.5Q813 1142 841 1137Z" />
      <path transform="translate(2272 0)" d="M627 991Q479 991 393.0 875.5Q307 760 307 559Q307 358 392.5 242.5Q478 127 627 127Q774 127 860.0 243.0Q946 359 946 559Q946 758 860.0 874.5Q774 991 627 991ZM627 1147Q867 1147 1004.0 991.0Q1141 835 1141 559Q1141 284 1004.0 127.5Q867 -29 627 -29Q386 -29 249.5 127.5Q113 284 113 559Q113 835 249.5 991.0Q386 1147 627 1147Z" />
      <path transform="translate(3525 0)" d="M627 991Q479 991 393.0 875.5Q307 760 307 559Q307 358 392.5 242.5Q478 127 627 127Q774 127 860.0 243.0Q946 359 946 559Q946 758 860.0 874.5Q774 991 627 991ZM627 1147Q867 1147 1004.0 991.0Q1141 835 1141 559Q1141 284 1004.0 127.5Q867 -29 627 -29Q386 -29 249.5 127.5Q113 284 113 559Q113 835 249.5 991.0Q386 1147 627 1147Z" />
      <path transform="translate(4778 0)" d="M371 168V-426H186V1120H371V950Q429 1050 517.5 1098.5Q606 1147 729 1147Q933 1147 1060.5 985.0Q1188 823 1188 559Q1188 295 1060.5 133.0Q933 -29 729 -29Q606 -29 517.5 19.5Q429 68 371 168ZM997 559Q997 762 913.5 877.5Q830 993 684 993Q538 993 454.5 877.5Q371 762 371 559Q371 356 454.5 240.5Q538 125 684 125Q830 125 913.5 240.5Q997 356 997 559Z" />
    </g>
  </svg>
);

export default CroopBrandLogo;
